import React from "react";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import { MdPeople } from "react-icons/md";
import Colors from "../../../assets/styles/Colors";

export default function CommunityView() {
  return (
    <Box sx={{ width: "100%", py: 3 }}>
      <Container maxWidth="xl">
        <Paper
          sx={{
            mb: 3,
            p: 2.5,
            borderRadius: 3,
            background: `linear-gradient(135deg, ${Colors.bgSecondary} 0%, ${Colors.bgTertiary} 100%)`,
            border: `1px solid ${Colors.borderSecondary}`,
          }}
        >
          <Typography variant="h5" sx={{ color: Colors.textPrimary }}>
            Comunidad
          </Typography>
          <Typography variant="body2" sx={{ color: Colors.textSecondary, mt: 0.5 }}>
            Gestión del módulo de comunidad
          </Typography>
        </Paper>

        <Paper
          sx={{
            p: 8,
            borderRadius: 3,
            backgroundColor: Colors.bgSecondary,
            border: `1px solid ${Colors.borderSecondary}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            minHeight: 340,
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "20px",
              display: "grid",
              placeItems: "center",
              background: "rgba(151, 71, 255, 0.1)",
              border: `1px solid rgba(151, 71, 255, 0.22)`,
              color: Colors.primaryLight,
              fontSize: 36,
              mb: 1,
            }}
          >
            <MdPeople />
          </Box>
          <Stack spacing={0.75} alignItems="center">
            <Typography
              variant="h6"
              sx={{ color: Colors.textPrimary, fontWeight: 700, letterSpacing: 1 }}
            >
              EN DESARROLLO
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: Colors.textSecondary,
                textAlign: "center",
                maxWidth: 380,
                lineHeight: 1.7,
              }}
            >
              El módulo de comunidad está actualmente en construcción. Pronto
              podrás gestionar publicaciones, miembros y contenido de la
              comunidad desde aquí.
            </Typography>
          </Stack>
          <Box
            sx={{
              mt: 2,
              px: 2.5,
              py: 0.75,
              borderRadius: "20px",
              background: "rgba(255, 159, 10, 0.1)",
              border: "1px solid rgba(255, 159, 10, 0.3)",
            }}
          >
            <Typography
              variant="caption"
              sx={{ color: Colors.warning, fontWeight: 700, letterSpacing: 1.2 }}
            >
              PRÓXIMAMENTE
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
